<template>
  <Modal
    class="holamundo"
    :title="'Boletos Excluídos'"
    :active.sync="popupBoletosExcluidos"
    @close="popupBoletosExcluidos = false"
  >
    <vs-alert v-if="!dadosBoletosExcluidos.length"
      class="my-3 text-left"
      style="height: auto"
      type="info"
    >
      Nenhum boleto encontrado
    </vs-alert>

    <vs-collapse v-else type="border">
      <vs-collapse-item v-for="item in dadosBoletosExcluidos" :key="item.id">
        <div slot="header">
          <template v-if="item.vehicles">
            <vs-chip
              v-for="veiculo in item.vehicles" :key="veiculo.id"
              class="mr-4"
              color="dark"
            >
              {{ veiculo.plate }}
            </vs-chip>

            <vs-chip
              class="mr-4"
              color="danger"
            >
              EXCLUÍDO
            </vs-chip>
          </template>

          {{ formatarDescricaoItem(item) }}
        </div>

        <vs-row>
          <table class="table table-bordered">
            <tr v-if="item.ourNumber">
              <th class="uppercase">Nosso Número</th>
              <td>{{ item.ourNumber }}</td>
            </tr>

            <tr>
              <th class="uppercase">Boleto Físico</th>
              <td>
                {{ formataBoletoFisico(item) }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Data de Emissão</th>
              <td>
                {{ formataData(item.issueDate) }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Data de Vencimento</th>
              <td>
                {{ formataDataUTCAux(item.dueDate) }}
              </td>
            </tr>

            <tr v-if="item.data_pagamento">
              <th class="uppercase">Data de Pagamento</th>
              <td>
                {{ formataData(item.paymentDate) }}
              </td>
            </tr>

            <tr v-if="item.manualCancellationDate && item.cancelledByUser">
              <th class="uppercase">Exclusão</th>
              <td>
                em {{ formataData(item.manualCancellationDate) }}, por
                {{ item.cancelledByUser.name }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Valor</th>
              <td>{{ item.boletoValue | currency }}</td>
            </tr>

            <tr v-if="item.paymentAmount">
              <th class="uppercase">Valor Pago</th>
              <td>
                {{ item.paymentAmount | currency }}
              </td>
            </tr>

            <tr v-if="item.digitableLine">
              <th class="uppercase">Linha Digitavel</th>
              <td>{{ item.digitableLine }}</td>
            </tr>

            <tr v-if="item.digitableLine">
              <th class="uppercase">Link Boleto</th>
              <td>
                <router-link
                  target="_blank"
                  :to="`/Boleto/${item.id}?nn=${item.ourNumber}`"
                  >Visualizar Boleto</router-link
                >
              </td>
            </tr>

            <tr v-if="item.remarks">
              <th class="uppercase">Observação</th>
              <td style="word-break: break-all">
                {{ item.remarks }}
              </td>
            </tr>

            <tr v-if="item.cancellationReason">
              <th class="uppercase">Motivo Exclusão</th>
              <td style="word-break: break-all">
                {{ item.cancellationReason }}
              </td>
            </tr>
          </table>
        </vs-row>

        <vs-row v-if="item.vehicles && item.vehicles.length">
          <table
            class="table table-bordered"
            style="border-top: 1px solid black"
          >
            <tr>
              <th class="uppercase">Veiculo</th>
              <th class="uppercase text-center">Placa</th>
            </tr>
            <tr
              v-for="veiculo in item.vehicles"
              :key="veiculo.id"
            >
              <td>{{ veiculo.vehicleModel }}</td>
              <td class="text-center" valing="top">
                {{ veiculo.plate }}
              </td>
            </tr>
          </table>
        </vs-row>
      </vs-collapse-item>
    </vs-collapse>
  </Modal>
</template>

<script>  
import Modal from '../../components/Modal.vue';
export default {
    name: 'ModalBoletosExcluidos',

    components: { Modal},
    
    props: [
      'dadosBoletosExcluidos',
      'formataDataUTCAux',
      'formataBoletoFisico',
      'formataData',
      'getInstallmentStatusColor'
    ],

    data() {
      return {
        popupBoletosExcluidos: false
      }
    },

    watch: {
      dadosBoletosExcluidos() {
        this.popupBoletosExcluidos = true;
      }
    },

    methods: {
      formatarDescricaoItem(item) {
        let str = '';

        item.description && (str += item.description);
        item.referenceMonth && (str += ` ${item.referenceMonth}`);
        item.dueDate &&
          (str += ` ${this.formataDataUTCAux(item.dueDate)}`);
        item.billetType && item.billetType.ticketType && (str += ` - ${item.billetType.ticketType}`);

        return str;
      }
    }
  }
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
